import { render } from "./BadgeComponent.vue?vue&type=template&id=53dd8012"
import script from "./BadgeComponent.vue?vue&type=script&lang=js"
export * from "./BadgeComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__